export const state = {
  isBookmarked: false,
  fundingStats: {
    current: 89_914,
    goal: 100_000,
    backers: 5_007,
    days: 56,
  },
  activeTier: null,
  tiers: [
    {
      id: 0,
      title: `Pledge with no reward`,
      text: `Choose to support us without a reward if you simply believe in our project. As a backer, you will be signed up to receive product updates via email.`,
      minPledge: 1,
      hasReward: false,
      stock: null,
    },
    {
      id: 1,
      title: `Bamboo Stand`,
      text: `You get an ergonomic stand made of natural bamboo. You've helped us launch our promotional campaign, and you’ll be added to a special Backer member list.`,
      minPledge: 25,
      hasReward: true,
      stock: 101,
    },
    {
      id: 2,
      title: `Black Edition Stand`,
      text: `You get a Black Special Edition computer stand and a personal thank you. You’ll be added to our Backer member list. Shipping is included.`,
      minPledge: 75,
      hasReward: true,
      stock: 64,
    },
    {
      id: 3,
      title: `Black Edition Stand`,
      text: `You get two Special Edition Mahogany stands, a Backer T-Shirt, and a personal thank you. You’ll be added to our Backer member list. Shipping is included.`,
      minPledge: 200,
      hasReward: true,
      stock: 0,
    },
  ],

  getTiers(includeNoReward = true) {
    // 1) Only return tiers with reward
    if (!includeNoReward) {
      return this.tiers.filter((tier) => tier.hasReward);
    }

    // 2) Else return all tiers
    return this.tiers;
  },

  setActiveTier(id) {
    // 1) Get tier with matching ID
    const tier = this.tiers.find((tier) => id === tier.id);

    // 2) Return if no matching ID found
    if (!tier) return;

    // 3) Update activeTier property
    this.activeTier = tier;
  },
};
